import {
  DEFAULT_LANGUAGE,
  SUPPORTED_LANGUAGES,
  type SupportedLanguage,
} from '../types';

const normalizeLanguage = (value?: string | null): SupportedLanguage | null => {
  if (!value) {
    return null;
  }

  const normalized = value.trim().toLowerCase();
  const base = normalized.split(/[-_]/)[0];

  return SUPPORTED_LANGUAGES.includes(base as SupportedLanguage)
    ? (base as SupportedLanguage)
    : null;
};

export const detectUrlLanguage = (): SupportedLanguage | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const params = new URLSearchParams(window.location.search);
  const lang = params.get('lang');

  if (!lang) {
    return null;
  }

  const normalized = normalizeLanguage(lang);
  if (!normalized) {
    console.warn(
      `Unsupported language '${lang}' in ?lang= parameter. Supported: ${SUPPORTED_LANGUAGES.join(', ')}`
    );
  }

  return normalized;
};

export const detectBrowserLanguage = (): SupportedLanguage => {
  if (typeof navigator === 'undefined') {
    return DEFAULT_LANGUAGE;
  }

  const candidates = Array.isArray(navigator.languages)
    ? navigator.languages
    : [];
  const ordered = [...candidates, navigator.language];

  for (const candidate of ordered) {
    const normalized = normalizeLanguage(candidate);
    if (normalized) {
      return normalized;
    }
  }

  return DEFAULT_LANGUAGE;
};
